export class LocaleTypes {
    public static readonly LocaleTypeDE = 'f5d10bfe-c818-48c4-a16d-8fb4f46d862d';
    public static readonly LocaleTypeEN = '1939dc53-07ed-4ade-8d00-ff7e4e6dcb32';


    public static readonly LocaleTypeDE_CODE = 'de-DE';
    public static readonly LocaleTypeEN_CODE = 'en-GB';
   
}